import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/itunes-note': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M381.9 388.2C375.5 415.6 354.7 431 326.8 436.2 302.3 440.7 281.9 441.8 262.3 426 238.4 405.9 238.1 372.6 259.6 351.6 276.6 335.4 300.5 332.1 336.4 325.8 342.4 324.7 347.6 323.3 352 318.4 358.4 311.2 356.4 314.3 356.4 155.2 356.4 144 350.9 140.9 339.4 142.9 331.2 144.3 153.7 177.5 153.7 177.5 143.5 179.7 140.3 182.7 140.3 194.2 140.3 428.9 141.4 418.1 137.8 433.7 133.6 451.9 122.4 465.6 107.6 473.2 90.8 482.5 60.4 486.6 44.2 483.6 1 475.5-14.2 425.6 15.1 397 32.1 380.8 56 377.5 91.9 371.2 97.9 370.1 103.1 368.7 107.5 363.8 117.6 352.3 109.3 107.2 112.7 93.6 113.5 88.4 115.7 84 119.8 80.7 124 77.2 131.6 75.2 133.2 75.2 337.2 37 362.1 32.1 365.6 32.1 377.1 31.3 383.7 38.1 383.7 49.7 383.9 394.2 384.8 375.7 381.9 388.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/itunes-note.js
// module id = jiwE
// module chunks = 144